import { Injectable, signal } from '@angular/core';
import { Listing } from '../shared/dto';

@Injectable({
  providedIn: 'root',
})
export class ResultsService {
  private readonly _listings = signal<Listing[]>([]);
  private readonly _activeIndex = signal<number>(0);
  private readonly _firstResultArrivalId = signal<number>(0);
  private readonly _redirectOnFirstResultArmed = signal<boolean>(true);

  public readonly listings = this._listings.asReadonly();
  public readonly activeIndex = this._activeIndex.asReadonly();
  public readonly firstResultArrivalId =
    this._firstResultArrivalId.asReadonly();

  public addResult(newListing: Listing): void {
    const wasEmpty = this._listings().length === 0;
    this._listings.update((listings) => [...listings, newListing]);
    if (wasEmpty && this._redirectOnFirstResultArmed()) {
      this._firstResultArrivalId.update((id) => id + 1);
      this._redirectOnFirstResultArmed.set(false);
    }
  }

  public clearResults(): void {
    this._activeIndex.set(0);
    this._listings.set([]);
    this._redirectOnFirstResultArmed.set(true);
  }

  public updateActiveIndex(activeIndex: number): void {
    const index = activeIndex >= 0 ? activeIndex : 0;
    this._activeIndex.set(index);
  }

  public removeResult(index: number): void {
    this._listings.update((props) => props.filter((_, i) => i !== index));
  }
}
